module.exports = __webpack_public_path__ + "static/media/gileadiconchatA.0b7ea7ff.svg";